export default {
    button: {
        signIn: "Sign in",
        forgotPassword: "Forgot password",
        readMore: "Read more",
        changePassword: "Change password",
        reset: "Reset",
        downloadVerification: "Download verification",
        downloadVerificationPDF: "Download verification PDF",
        downloadCategoryPDF: "Download Category",
        downloadReportPreview: "Download for signing",
        categoryList: "Category list",
        approve: "Submit review",
        updateProfile: "Update profile",
        save: "Save",
        cancel: "Cancel",
        confirm: "Confirm",
        proceedAnyway: "Proceed anyway",
        submit: "Submit",
        sendBack: "Send back",
        saveReviewNote: "Save remark",
        saveNotifications: "Save recipients",
        requestAttachmentCompletion: "Request completion",
        cancelAttachmentCompletion: "Cancel completion",
        removeAttachment: "Remove",
        previewAttachment: "Open",
        navigate: "Navigate",
        linkGoogle: "Link Google provider",
        unlinkGoogle: "Unlink Google provider",
        changePhoto: "Change photo",
        removePhoto: "Remove photo",
    },
    label: {
        email: "Email",
        username: "Username",
        password: "Password",
        repeatPassword: "Repeat password",
        firstName: "First name",
        lastName: "Last name",
        currentPassword: "Current password",
        newPassword: "New password",
        repeatNewPassword: "Repeat new password",
        showReviewed: "Show reviewed reports",
        search: "Search",
        reviewNote: "Remark",
    },
    placeholder: {
        email: "Enter your email address",
        username: "Enter your username",
        password: "Enter your password",
        repeatPassword: "Repeat your password",
        firstName: "Enter your first name",
        lastName: "Enter your last name",
        currentPassword: "Enter your current password",
        newPassword: "Enter your new password",
        repeatNewPassword: "Repeat your new password",
        search: "Search here...",
        reviewNote: "Write a remark (optional)",
    },
    navigation: {
        profile: "Profile",
        logout: "Logout",
        overview: "Overview",
        reports: "Reports",
        auditedReports: "Audited reports",
        organizationSettings: "Organization Settings",
        helpCenter: "Help Center",
    },
    reportColumn: {
        name: "Name",
        principal: "Principal",
        trustee: "Trustee",
        trusteePersonalID: "Trustee personal ID",
        personalID: "Personal ID",
        type: "Type",
        reportStart: "Report Start",
        reportEnd: "Report End",
        receivedAt: "Received Date",
        status: "Status",
        open: "Open",
        reviewed: "Reviewed",
        notReviwed: "Not Reviewed",
        registered: "Registered",
    },
    reportVariant: {
        arsrakning: "ÅR",
        slutrakning: "SR",
        forteckning: "FT",
    },
    auditedReportOverview: "Audited reports",
    messages: {
        success: {
            passwordResetLink: "Password reset link sent to %{to}.",
            saveReport: "Report has been successfully saved.",
            updateReport: "Report has been successfully updated.",
            reviewStatusUpdate: "Review status updated: %{status}.",
            profileUpdate: "Profile has been successfully updated.",
            passwordUpdate: "Password has been successfully updated.",
            attachmentCompletionRequested: "Attachment completion request sent.",
            attachmentCompletionCancelled: "Attachment completion request cancelled.",
            complementAcknowledgedSuccess: "Complement attachments acknowledged.",
            notificationsUpdate: "Notification settings saved.",
        },
        info: {
            loadingPreview: "Loading preview...",
            saveDisabledReviewNotes: "Save the remark in the section below.",
        },
        error: {
            filePreview: "Preview is limited to PDF and image files.",
            unknownError: "Unknown error.",
        },
    },
    alert: {
        error: "Something went wrong! Please refresh the page and try again.",
        form: {
            title: "Your changes will be lost!",
            message:
                "Please save your changes before navigating away, otherwise, all the changes will be lost.",
        },
        report: {
            submit: {
                title: "Confirm submission",
                message: "You are about to submit the review decision.",
                notice: "The signed attachment and the review decision must now be handed over to the trustee manually.",
                disclaimer: "NOTE: Digital signing is under development and will be launched with the new legal framework in July 2026.",
                confirm: "Confirm and submit",
            },
        },
        reportColumn: {
            register: {
                title: "Are you sure you want to mark this as registered?",
            },
            unregister: {
                title: "Are you sure you want to mark this as not registered?",
            },
        },
    },
    reportStatus: {
        0: "Not reviewed",
        1: "Reviewed without remarks",
        2: "Reviewed with remarks",
        3: "Reviewed with adjustments",
        4: "Request new report for completion",
    },
    reportStatusDescription: {
        1: "Report approved without remarks",
        2: "Minor remarks noted",
        3: "Requires adjustments before approval",
        4: "The report needs to be resubmitted",
    },
    reviewStatusSelect: "Select review status",
    reportReview: {
        sectionTitle: "Remarks",
        finalReviewTitle: "Complete review",
        noteHelper: "Add a remark if you want (optional).",
        noteLimit: "Max %{max} characters (%{count}/%{max}), max %{maxLines} lines",
        signedUploadTitle: "Save signed report",
        signedUploadHelper: "Upload and save the scanned report for your records.",
        signedUploadButton: "Choose file",
        signedUploadDisclaimer: "NOTE: The file is not included with the submission yet.",
    },

    notifications: {
        sectionTitle: "Notification on incoming report",
        helper: "We send an email when something new has arrived. It contains no case data and no personal data — only that there is something to review, and a link to the portal.",
        toggleLabel: "Send notification",
        recipientsLabel: "Recipients",
        recipientsHelper:
            "Add one or more addresses, for example your shared function mailbox. Press Enter after each address.",
        frequencyNote: "Reports arriving close together are collected into a single notification.",
    },
    categoryStatus: {
        0: "Not reviewed",
        1: "Reviewed",
        2: "Reviewed through sampling",
        3: "Assessed for reasonableness",
    },
    validation: {
        notifications: {
            email: {
                invalid: "Invalid email format",
                duplicate: "That address is already in the list",
            },
            recipients: {
                required: "Add at least one recipient when notifications are on",
                max: "At most %{max} recipients",
            },
        },
        resetPassword: {
            email: {
                invalid: "Invalid email address",
                required: "Email address is required",
            },
        },
        signIn: {
            email: {
                invalid: "Invalid email format",
                required: "Email is required",
            },
            password: {
                min: "Password must be at least 8 characters",
                required: "Password is required",
            },
        },
        profile: {
            photoURL: {
                nullable: "Photo URL is invalid",
            },
            firstName: {
                required: "First name is required",
            },
            lastName: {
                required: "Last name is required",
            },
            email: {
                invalid: "Invalid email format",
                nullable: "Email is invalid",
            },
        },
        changePassword: {
            currentPassword: {
                min: "Must be at least 8 characters",
            },
            newPassword: {
                required: "New password is required",
                min: "Must be at least 8 characters",
                specialCharacter: "Password must contain at least one special character",
                different: "New password must be different from the current password",
            },
            repeatNewPassword: {
                required: "Repeat password is required",
                match: "Passwords don't match",
            },
            password: {
                min: "Must be at least 8 characters",
                specialCharacter: "Password must contain at least one special character",
            },
            repeatPassword: {
                required: "Repeat password is required",
                match: "Passwords don't match",
            },
        },
    },
    reportOverview: "Report Overview",
    reportPreview: {
        title: "Unsigned report",
        description: "Download for printing and signing.",
        dialogTitle: "Select pages for signing",
        dialogHelp: "Choose which sections to include in the PDF.",
        outcomeTitle: "Review choice in the report",
        outcomes: {
            WITHOUT_REMARKS: "Without remarks",
            WITH_CORRECTION: "With correction",
            WITH_REMARKS: "With remarks",
        },
        pages: {
            FRONT_PAGE: "Front page",
            ECONOMIC_SUMMARY: "Economic summary",
            ASSETS_DEBTS: "Assets and debts",
            INCOMES_EXPENSES: "Incomes and expenses",
            VERIFICATIONS: "Verification list",
            LEDGER: "Category specification",
        },
    },
    registryExport: {
        button: "Download registry document",
        dialogTitle: "Registry document for report",
        dialogHelp:
            "Select which report sections and attachments to include. Everything is combined into one PDF that you file in your own registry.",
        sectionsTitle: "Report sections",
        noSectionMap:
            "This report was received before section support — the full report is included.",
        attachmentsTitle: "Attachments",
        attachmentsHelp: "Selected attachments are converted to PDF and appended after the report.",
        download: "Download document",
    },
    result: "results",
    rowsPerPage: "rows per page",
    of: "of",
    personalData: "Personal data",
    annualReport: "Annual report, attachments",
    complementAttachments: "Received complements",
    complementReceived: "Received complements",
    completionRequested: "Attachment completion requested",
    acknowledgeComplement: "Acknowledge complement",
    complementAcknowledged: "Acknowledged",
    complementReceivedMessage: "Complements have been received. Acknowledge to confirm they have been reviewed.",
    acknowledgeComplementTitle: "Acknowledge complement?",
    acknowledgeComplementDescription: "You confirm that the complement attachments have been reviewed and received. The complement marker will be removed from the report list.",
    acknowledgeComplementConfirm: "Yes, acknowledge",
    noComplementAttachments: "No received complements",
    requestComplementTitle: "Request completion?",
    requestComplementDescription: "This sends a request for attachment completion. Note that the trustee is not notified automatically – you need to contact the trustee yourself to inform them that a completion has been requested.",
    requestComplementConfirm: "Yes, request completion",
    economicOverview: "Economic overview",
    assetsAndLiabilities: "Assets and liabilities",
    preview: "Preview",
    incomings: "Income",
    outgoings: "Expense",
    debts: "Debts",
    category: "Category",
    amount: "Amount",
    comment: "Comment",
    status: "Status",
    caseOverview: "Case overview",
    difference: "Difference",
    incomeDuringPeriod: "Income during this period",
    expenseDuringPeriod: "Expenses during this period",
    bankFundsAsOf: "Bank funds as of %{date}",
    transactionAccounts: "Transaction accounts",
    account: "Account",
    accountNumber: "Account number",
    otherBankAccounts: "Other bank accounts and assets",
    type: "Type",
    description: "Description",
    sumA: "Sum A",
    sumD: "Sum D",
    date: "Date",
    importSource: "Source",
    importSourceBank: "Bank connection",
    importSourceFile: "File",
    importSourceManual: "Manual",
    balance: "Balance",
    download: "Download",
    downloading: "Downloading",
    downloaded: "Downloaded",
    startDate: "Start Date",
    endDate: "End Date",
    selectDateRange: "Select Date Range",
    clearFilter: "Clear Filter",
    verificationList: "Verification list",
    CategoryList: "Category list",
    verification: "Verification",
    tag: "Tag",
    taxDeduction: "Tax deduction",
    selectCategories: "Select categories",
    categorySpecification: "Category specification",
    chooseMunicipality: "Choose municipality",
    yourMunicipalities: "Your municipalities",
};
